/* esm.sh - d3-transition@3.0.1/src/selection/interrupt */
export * from "/*d3-transition@3.0.1/esnext/src/selection/interrupt.mjs";
export { default } from "/*d3-transition@3.0.1/esnext/src/selection/interrupt.mjs";
